import { IS_BETA_ENV } from 'Constants/env';
import { MobXProviderContext, observer } from 'mobx-react';
import { useUIStore } from 'Modules/ui/index.store';
import { getIsSmallScreen } from 'Modules/ui/secondaryMenu/utils';
import React from 'react';
import { Grid } from 'semantic-ui-react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import { Styled } from './index.styles';
import { LogoButton } from './LogoButton';
import { TopBarDropdown } from './TopBarDropdown';
import { TopBarUser } from './TopBarUser';

export const TopBar: React.FC = observer(() => {
  const {
    ui: { isTouchSupported },
  } = React.useContext<RootStoreProps>(MobXProviderContext);
  const setIsSecondaryMenuOpen = useUIStore(
    (state) => state.setIsSecondaryMenuOpen
  );
  const testid = 'topBar';

  return (
    <Grid.Row
      className="app-header"
      onMouseEnter={() => {
        if (!isTouchSupported() && getIsSmallScreen()) {
          setIsSecondaryMenuOpen(false);
        }
      }}
    >
      <LogoButton {...{ testid }} />
      {IS_BETA_ENV && <Styled.BetaLogoText>BETA</Styled.BetaLogoText>}
      <Grid.Column className="action-button-wrapper">
        <TopBarDropdown />
      </Grid.Column>
      <TopBarUser {...{ testid }} />
    </Grid.Row>
  );
});
